import styled from 'styled-components';

export const HorizontalDivider = styled.div`
  border: ${({ theme }) => theme.background_secondary} solid 0.063rem;
  justify-self: center;
  align-self: center;
`;
